export const environment = {
  production: true,
  apiUrl: 'https://api.1riskint.com/',
  portalUrl: 'https://apps.1risk.cloud/',
	formsUrl: 'https://forms.1risk.cloud/',
  formsSls: 'https://1forms.1riskint.com/',
};
